import { Roles } from './roles';

export enum PlatformType {
  ADMIN = 'ADMIN',
  LEARNING = 'LEARNING',
}

export const PLATFORM_TYPE_FROM_ROLE = {
  [Roles.Admin]: PlatformType.ADMIN,
  [Roles.HR_Delegate]: PlatformType.ADMIN,
  [Roles.Manager]: PlatformType.LEARNING,
  [Roles.Employee]: PlatformType.LEARNING,
};

export const ROLES_FROM_PLATFORM_TYPE: Record<PlatformType, Roles[]> = (
  Object.entries(PLATFORM_TYPE_FROM_ROLE) as [Roles, PlatformType][]
).reduce(
  (acc, [role, platform]) => {
    acc[platform].push(role);
    return acc;
  },
  {
    [PlatformType.ADMIN]: [] as Roles[],
    [PlatformType.LEARNING]: [] as Roles[],
  },
);
